$(document).ready(function(){

	$('a[href^="#"]').on('click', function(e){
		e.preventDefault();
		
		var id = $(this).attr("href");
	
		$('html, body').animate({
			scrollTop: $(id).offset().top - 56
		}, 'slow');
		return false;
	});

});